










































import { Guid } from 'guid-typescript'
import Vue from 'vue'
import { Component, Emit, Prop, Watch } from 'vue-property-decorator'

import { PlaceholdersOnes, PlaceholdersStack } from '../../../../components/Editor/components/Toolbar/types'
import EmptyData from '../../../../components/EmptyData/EmptyData.vue'
import { AvailableButtonsTypes } from '../../../../components/NewMessageEditors/NewMessageEditorWithMedia/ButtonsConstructor/logic/types';
import { SelectOption } from '../../../../logic/types'
import { IterableItemFactory } from '../../../utils/IterableItemFactory'
import { getMessageActionTemplate } from "../ActivationAction";
import { UserActivationActionTypeEnum } from '../ActivationAction/types'
import ActionCard from './components/ActionCard.vue'
import {
  AutoReplyAction, AutoReplyConditions,
  AutoReplyConditionTypeEnum, LocalAutoReplyAction,
  AutoReplyActions
} from './types'

@Component({
  components: {
    EmptyData,
    ActionCard,
  }
})
export default class AutoReplyActionsSetup extends Vue {
  @Prop() autoReplyActions!: AutoReplyActions

  @Prop({ type: Boolean, default: false }) commandsConditions!: boolean

  @Prop() flowOptions!: Array<SelectOption>

  @Prop() emptyFlowButtonCallback!: () => void

  @Prop() boardKey!: string

  @Prop() placeholders!: PlaceholdersOnes | PlaceholdersStack

  @Prop() editorButtons!: AvailableButtonsTypes

  @Prop() limitTypes!: Array<UserActivationActionTypeEnum>

  actionsCopy: Array<LocalAutoReplyAction> | null = null

  itemFactory = new IterableItemFactory()

  @Watch('autoReplyActions')
  onActionsChange() {
    this.prepareActions()
  }

  @Emit()
  updateActions(actionsCopy: Array<LocalAutoReplyAction>) {
    return actionsCopy.map(a => this.getRawAction(a))
  }

  removeAction(guid: AutoReplyAction['guid']) {
    if (this.actionsCopy) {
      this.actionsCopy = this.actionsCopy.filter(a => a.guid !== guid)

      if (this.autoReplyActions.findIndex(a => a.guid === guid) !== -1) {
        this.updateActions(this.actionsCopy)
      }
    }
  }

  getRawAction(action: LocalAutoReplyAction): AutoReplyAction {
    return {
      guid: action.guid,
      action: action.action,
      conditions: action.conditions.map(g => g.value.map(c => c.value))
    }
  }

  saveAction(action: LocalAutoReplyAction) {
    if (this.actionsCopy) {
      const idx = this.actionsCopy.findIndex(a => a.guid === action.guid)

      if (idx !== -1) {
        this.actionsCopy.splice(idx, 1, action)

        this.updateActions(this.actionsCopy)
      }
    }
  }

  addAction(): void {
    const guid = Guid.create().toString()

    this.actionsCopy!.push({
      guid: guid,
      conditions: [ this.itemFactory.create([ this.itemFactory.create(this.getConditionTemplate()) ]) ],
      action: getMessageActionTemplate(this.$i18n),
    })

    this.scrollToCard(guid)
  }

  scrollToCard(guid: string) {
    this.$nextTick(() => {
      const refs = this.$refs[`action-${ guid }`] as Array<Vue> | undefined

      if (Array.isArray(refs) && refs.length) {
        const el = refs[0].$el

        el.scrollIntoView({ behavior: 'smooth' })
      }
    })
  }

  getConditionTemplate(): AutoReplyConditions {
    return {
      type: this.commandsConditions ? AutoReplyConditionTypeEnum.Equals : AutoReplyConditionTypeEnum.Contains,
      invert: false,
      values: []
    }
  }

  prepareActions(): void {
    this.actionsCopy = this.convertRawActionsToFrontend(this.autoReplyActions ?? [])
  }

  convertRawActionsToFrontend(actions: AutoReplyActions) {
    return actions
      .map(a => {
        return {
          ...a,
          conditions: a.conditions.map(g => this.itemFactory.create(g.map(c => this.itemFactory.create(c))))
        }
      })
  }

  created(): void {
    this.prepareActions()
  }
}
